import { render } from "./AssignSyndicatedPublishingPlatformModal.vue.js?vue&type=template&id=5ad8a76f!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AssignSyndicatedPublishingPlatformModal.vue?vue&type=template&id=5ad8a76f"
import script from "./AssignSyndicatedPublishingPlatformModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AssignSyndicatedPublishingPlatformModal.vue?vue&type=script&lang=js"
export * from "./AssignSyndicatedPublishingPlatformModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AssignSyndicatedPublishingPlatformModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/AssignSyndicatedPublishingPlatformModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ad8a76f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ad8a76f', __exports__)) {
    api.reload('5ad8a76f', __exports__)
  }
  
  module.hot.accept("./AssignSyndicatedPublishingPlatformModal.vue.js?vue&type=template&id=5ad8a76f!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AssignSyndicatedPublishingPlatformModal.vue?vue&type=template&id=5ad8a76f", () => {
    api.rerender('5ad8a76f', render)
  })

}


export default __exports__